module.exports = {
  interface: {
    method: 'GET',         // 接口方式
    api_url: '',           // 接口地址
    key: '',               // 关键传入参数名 例如:vin
    data: '',              // 接口传入参数  用':'写键值对，多参数用',' 隔开，例如:key:123456,appid:123
    status: '',            // 返回状态参数 用'/'作为多维数组分隔符,例如:ret/status
    success_status: '',    // 正常参数值
    content: '',           // 返回参数内容 用'/'作为多维数组分隔符,例如:ret/info
    error_msg: [
      {
        error_code: 0,      // 返回的错误码
        msg: ''             // 错误提示信息
      }
    ],
    set_field: [
      {
        param: '',          // 返回的参数名
        fieldname: ''       // 对应本表单的字段控件
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/components/Model/widgetAttr/interface.js